import { createRequest, ValidationError } from '@shared/services';

export type CategoryErrors = {
    data?: Category[];
    errors: CategoryErrorFields;
};

export async function getProductCategory(keyword?: string) {
    const request = createRequest<CategoryResponse>({
        url: '/product/category',
        method: 'GET',
        withAuthorization: true,
        params: {
            keyword,
        },
    });

    return request.execute();
}

export async function postProductCategory(payload: CategoryPayload[]) {
    let result: CategoryResponse | null = null;
    let errors: CategoryErrorFields | null = null;

    try {
        const request = createRequest<CategoryResponse>({
            url: '/product/category',
            method: 'POST',
            data: payload,
            withAuthorization: true,
        });

        result = await request.execute();
    } catch (error) {
        if (error instanceof ValidationError) {
            const details = error.context.detail;

            errors = {} as CategoryErrorFields;

            if (Array.isArray(details)) {
                for (let i = 0; i < details.length; i++) {
                    const errorField = details[i];
                    const [, field] = errorField.loc;

                    errors[field] = errorField.msg;
                }
            }
        }
    }

    if (errors) {
        return { errors } as CategoryErrors;
    }

    return result;
}

export async function putProductCategoryNode(
    categoryId: string,
    payload: CategoryPayload
) {
    const request = createRequest<CategoryNodeResponse>({
        url: `/product/category/${categoryId}/node`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putProductCategoryOrder(payload: CategoryOrderPayload) {
    const request = createRequest<CategoryResponse>({
        url: '/product/category/order',
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function putProductCategoryName(payload: CategoryNamePayload) {
    const request = createRequest<CategoryResponse>({
        url: `/product/category/name`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function deleteProductCategory(categoryIds: string[]) {
    const searchParams = new URLSearchParams();

    categoryIds.forEach((id) => searchParams.append('category_id', id));

    const request = createRequest<BasicSuccessResponse>({
        url: `/product/category?${searchParams.toString()}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}
